var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2168_8227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5556 41H37V26.65H30.8333V18.45H20.5556V14.35H26.7222V0H10.2778V14.35H16.4444V18.45H6.16667V26.65H0V41H16.4444V26.65H10.2778V22.55H26.7222V26.65H20.5556V41Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_8227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartments);
export default __webpack_public_path__ + "static/media/Departments.71a1191a5ae6234d6ef8e315172db3e6.svg";
export { ForwardRef as ReactComponent };